import { render, staticRenderFns } from "./TablePendencia.vue?vue&type=template&id=0cbca477"
import script from "./TablePendencia.vue?vue&type=script&lang=js"
export * from "./TablePendencia.vue?vue&type=script&lang=js"
import style0 from "./TablePendencia.vue?vue&type=style&index=0&id=0cbca477&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports